import request from '@/utils/request'


// 查询优惠券自动发放-用户列表
export function listCouponAuto(query) {
  return request({
    url: '/coupon/coupon/auto/list',
    method: 'get',
    params: query
  })
}

// 查询优惠券自动发放-用户分页
export function pageCouponAuto(query) {
  return request({
    url: '/coupon/coupon/auto/page',
    method: 'get',
    params: query
  })
}

// 查询优惠券自动发放-用户详细
export function getCouponAuto(data) {
  return request({
    url: '/coupon/coupon/auto/detail',
    method: 'get',
    params: data
  })
}

// 新增优惠券自动发放-用户
export function addCouponAuto(data) {
  return request({
    url: '/coupon/coupon/auto/add',
    method: 'post',
    data: data
  })
}

// 修改优惠券自动发放-用户
export function updateCouponAuto(data) {
  return request({
    url: '/coupon/coupon/auto/edit',
    method: 'post',
    data: data
  })
}

// 删除优惠券自动发放-用户
export function delCouponAuto(data) {
  return request({
    url: '/coupon/coupon/auto/delete',
    method: 'post',
    data: data
  })
}
